import React from 'react'
import ListComponentProto from './list-multi-proto'


export default function renderListInView(id:string, props:any) {
    return (
        <ListComponentProto
            renderMode="edit"
            id={id}
            {...props}
        />
    )
}
